import { useHistory } from "react-router-dom";

const RequestAccessSuccess = () => {

    let history = useHistory();


    const logout = () => {
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("auth");
        sessionStorage.removeItem("route");
        history.push("/");
      };

    return (
        <div style={{width: "100%", color: "black", textAlign: "center", marginTop: "50px"}}>
            <p>Thank you for your request.<br/>
            You will receive an email after your request has been accepted. <br/>
            <button type="button" onClick={logout} style={{textDecoration: "underline", cursor: "pointer", background: "none", border: "none", padding: 0, font: "inherit", color: "inherit"}}>Logout</button> now to continue to use WaterLink as a public user.</p>
        </div>
    );
}

export default RequestAccessSuccess;